import * as tslib_1 from "tslib";
import { Item, Field, Attr, Slot, Value, Record, Text, Num, Selector, InfixExpr, PrefixExpr, InvokeExpr, } from '@swim/recon';
import { Interpolator } from './interpolator';
var ReconInterpolator = (function (_super) {
    tslib_1.__extends(ReconInterpolator, _super);
    function ReconInterpolator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReconInterpolator.prototype.map = function (u) {
        return Item.Absent;
    };
    ReconInterpolator.prototype.unmap = function (c) {
        return 0;
    };
    ReconInterpolator.prototype.range = function (i0, i1) {
        if (i0 === undefined) {
            return [this.map(0), this.map(1)];
        }
        else if (i1 === undefined) {
            i0 = i0;
            return Interpolator.recon(i0[0], i0[1]);
        }
        else {
            return Interpolator.recon(i0, i1);
        }
    };
    ReconInterpolator.prototype.equals = function (that) {
        return this === that;
    };
    return ReconInterpolator;
}(Interpolator));
export { ReconInterpolator };
var AttrInterpolator = (function (_super) {
    tslib_1.__extends(AttrInterpolator, _super);
    function AttrInterpolator(f0, f1) {
        var _this = _super.call(this) || this;
        if (!f0 && !f1) {
            throw new TypeError();
        }
        else if (!f1) {
            f1 = f0;
        }
        else if (!f0) {
            f0 = f1;
        }
        if (!(f0.key instanceof Text)) {
            throw new TypeError('' + f0.key);
        }
        else if (!(f1.key instanceof Text)) {
            throw new TypeError('' + f1.key);
        }
        f0.commit();
        f1.commit();
        _this.keyInterpolator = Interpolator.recon(f0.key, f1.key);
        _this.valueInterpolator = Interpolator.recon(f0.value, f1.value);
        return _this;
    }
    AttrInterpolator.prototype.map = function (u) {
        var key = this.keyInterpolator.map(u);
        var value = this.valueInterpolator.map(u);
        return Attr.of(key, value);
    };
    AttrInterpolator.prototype.unmap = function (f) {
        return 0;
    };
    AttrInterpolator.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof AttrInterpolator) {
            return this.keyInterpolator.equals(that.keyInterpolator)
                && this.valueInterpolator.equals(that.valueInterpolator);
        }
        return false;
    };
    return AttrInterpolator;
}(ReconInterpolator));
export { AttrInterpolator };
var SlotInterpolator = (function (_super) {
    tslib_1.__extends(SlotInterpolator, _super);
    function SlotInterpolator(f0, f1) {
        var _this = _super.call(this) || this;
        if (!f0 && !f1) {
            throw new TypeError();
        }
        else if (!f1) {
            f1 = f0;
        }
        else if (!f0) {
            f0 = f1;
        }
        f0.commit();
        f1.commit();
        _this.keyInterpolator = Interpolator.recon(f0.key, f1.key);
        _this.valueInterpolator = Interpolator.recon(f0.value, f1.value);
        return _this;
    }
    SlotInterpolator.prototype.map = function (u) {
        var key = this.keyInterpolator.map(u);
        var value = this.valueInterpolator.map(u);
        return Slot.of(key, value);
    };
    SlotInterpolator.prototype.unmap = function (f) {
        return 0;
    };
    SlotInterpolator.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof SlotInterpolator) {
            return this.keyInterpolator.equals(that.keyInterpolator)
                && this.valueInterpolator.equals(that.valueInterpolator);
        }
        return false;
    };
    return SlotInterpolator;
}(ReconInterpolator));
export { SlotInterpolator };
var ValueInterpolator = (function (_super) {
    tslib_1.__extends(ValueInterpolator, _super);
    function ValueInterpolator(v0, v1) {
        var _this = _super.call(this) || this;
        if (v0 !== undefined) {
            v0 = Value.fromAny(v0);
        }
        if (v1 !== undefined) {
            v1 = Value.fromAny(v1);
        }
        if (!v0 && !v1) {
            v1 = v0 = Value.Absent;
        }
        else if (!v1) {
            v1 = v0;
        }
        else if (!v0) {
            v0 = v1;
        }
        _this.v0 = v0.commit();
        _this.v1 = v1.commit();
        return _this;
    }
    ValueInterpolator.prototype.map = function (u) {
        return u < 1 ? this.v0 : this.v1;
    };
    ValueInterpolator.prototype.unmap = function (v) {
        return v.equals(this.v1) ? 1 : 0;
    };
    ValueInterpolator.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof ValueInterpolator) {
            return this.v0.equals(that.v0) && this.v1.equals(that.v1);
        }
        return false;
    };
    return ValueInterpolator;
}(ReconInterpolator));
export { ValueInterpolator };
var RecordInterpolator = (function (_super) {
    tslib_1.__extends(RecordInterpolator, _super);
    function RecordInterpolator(r0, r1) {
        var _this = _super.call(this) || this;
        if (r0 !== undefined) {
            r0 = Record.fromAny(r0);
        }
        if (r1 !== undefined) {
            r1 = Record.fromAny(r1);
        }
        if (!r0 && !r1) {
            r1 = r0 = Record.Empty;
        }
        else if (!r1) {
            r1 = r0;
        }
        else if (!r0) {
            r0 = r1;
        }
        r0.commit();
        r1.commit();
        _this.interpolators = [];
        var n = Math.min(r0.length, r1.length);
        for (var i = 0; i < n; i += 1) {
            _this.interpolators.push(Interpolator.recon(r0.getItem(i), r1.getItem(i)));
        }
        return _this;
    }
    RecordInterpolator.prototype.map = function (u) {
        var n = this.interpolators.length;
        var record = Record.empty(n);
        for (var i = 0; i < n; i += 1) {
            record.push(this.interpolators[i].map(u));
        }
        return record;
    };
    RecordInterpolator.prototype.unmap = function (f) {
        return 0;
    };
    RecordInterpolator.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof RecordInterpolator) {
            var n = this.interpolators.length;
            if (n === that.interpolators.length) {
                for (var i = 0; i < n; i += 1) {
                    if (!this.interpolators[i].equals(that.interpolators[i])) {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
    };
    return RecordInterpolator;
}(ReconInterpolator));
export { RecordInterpolator };
var NumInterpolator = (function (_super) {
    tslib_1.__extends(NumInterpolator, _super);
    function NumInterpolator(y0, y1) {
        var _this = _super.call(this) || this;
        if (y0 === undefined && y1 === undefined) {
            y1 = y0 = 0;
        }
        else if (y1 === undefined) {
            y1 = y0;
        }
        else if (y0 === undefined) {
            y0 = y1;
        }
        _this.y0 = +y0;
        _this.dy = +y1 - _this.y0;
        return _this;
    }
    NumInterpolator.prototype.map = function (u) {
        return Num.valueOf(this.y0 + this.dy * u);
    };
    NumInterpolator.prototype.unmap = function (y) {
        return this.dy ? (y.value - this.y0) / this.dy : this.dy;
    };
    NumInterpolator.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof NumInterpolator) {
            return this.y0 === that.y0 && this.dy === that.dy;
        }
        return false;
    };
    return NumInterpolator;
}(ReconInterpolator));
export { NumInterpolator };
var InfixExprInterpolator = (function (_super) {
    tslib_1.__extends(InfixExprInterpolator, _super);
    function InfixExprInterpolator(e0, e1) {
        var _this = _super.call(this) || this;
        if (!e0 && !e1) {
            throw new TypeError();
        }
        else if (!e1) {
            e1 = e0;
        }
        else if (!e0) {
            e0 = e1;
        }
        _this.operator = e0.operator;
        if (_this.operator !== e1.operator) {
            throw new Error(e1.operator);
        }
        e0.commit();
        e1.commit();
        _this.lhsInterpolator = Interpolator.recon(e0.lhs, e1.lhs);
        _this.rhsInterpolator = Interpolator.recon(e0.rhs, e1.rhs);
        return _this;
    }
    InfixExprInterpolator.prototype.map = function (u) {
        var lhs = this.lhsInterpolator.map(u);
        var rhs = this.rhsInterpolator.map(u);
        switch (this.operator) {
            case '||': return lhs.or(rhs);
            case '&&': return lhs.and(rhs);
            case '|': return lhs.bor(rhs);
            case '^': return lhs.bxor(rhs);
            case '&': return lhs.band(rhs);
            case '<': return lhs.lt(rhs);
            case '<=': return lhs.le(rhs);
            case '==': return lhs.eq(rhs);
            case '!=': return lhs.ne(rhs);
            case '>=': return lhs.ge(rhs);
            case '>': return lhs.gt(rhs);
            case '+': return lhs.plus(rhs);
            case '-': return lhs.minus(rhs);
            case '*': return lhs.times(rhs);
            case '/': return lhs.divide(rhs);
            case '%': return lhs.modulo(rhs);
            default: throw new Error(this.operator);
        }
    };
    InfixExprInterpolator.prototype.unmap = function (f) {
        return 0;
    };
    InfixExprInterpolator.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof InfixExprInterpolator) {
            return this.lhsInterpolator.equals(that.lhsInterpolator)
                && this.rhsInterpolator.equals(that.rhsInterpolator);
        }
        return false;
    };
    return InfixExprInterpolator;
}(ReconInterpolator));
export { InfixExprInterpolator };
var PrefixExprInterpolator = (function (_super) {
    tslib_1.__extends(PrefixExprInterpolator, _super);
    function PrefixExprInterpolator(e0, e1) {
        var _this = _super.call(this) || this;
        if (!e0 && !e1) {
            throw new TypeError();
        }
        else if (!e1) {
            e1 = e0;
        }
        else if (!e0) {
            e0 = e1;
        }
        _this.operator = e0.operator;
        if (_this.operator !== e1.operator) {
            throw new Error(e1.operator);
        }
        e0.commit();
        e1.commit();
        _this.rhsInterpolator = Interpolator.recon(e0.rhs, e1.rhs);
        return _this;
    }
    PrefixExprInterpolator.prototype.map = function (u) {
        var rhs = this.rhsInterpolator.map(u);
        switch (this.operator) {
            case '!': return rhs.not();
            case '~': return rhs.bnot();
            case '-': return rhs.neg();
            default: throw new Error(this.operator);
        }
    };
    PrefixExprInterpolator.prototype.unmap = function (f) {
        return 0;
    };
    PrefixExprInterpolator.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof PrefixExprInterpolator) {
            return this.rhsInterpolator.equals(that.rhsInterpolator);
        }
        return false;
    };
    return PrefixExprInterpolator;
}(ReconInterpolator));
export { PrefixExprInterpolator };
var InvokeExprInterpolator = (function (_super) {
    tslib_1.__extends(InvokeExprInterpolator, _super);
    function InvokeExprInterpolator(e0, e1) {
        var _this = _super.call(this) || this;
        if (!e0 && !e1) {
            throw new TypeError();
        }
        else if (!e1) {
            e1 = e0;
        }
        else if (!e0) {
            e0 = e1;
        }
        e0.commit();
        e1.commit();
        _this.funcInterpolator = Interpolator.recon(e0.func, e1.func);
        _this.argsInterpolator = Interpolator.recon(e0.args, e1.args);
        return _this;
    }
    InvokeExprInterpolator.prototype.map = function (u) {
        var func = this.funcInterpolator.map(u);
        var args = this.argsInterpolator.map(u);
        return Selector.literal(func).invoke(args);
    };
    InvokeExprInterpolator.prototype.unmap = function (f) {
        return 0;
    };
    InvokeExprInterpolator.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof InvokeExprInterpolator) {
            return this.funcInterpolator.equals(that.funcInterpolator)
                && this.argsInterpolator.equals(that.argsInterpolator);
        }
        return false;
    };
    return InvokeExprInterpolator;
}(ReconInterpolator));
export { InvokeExprInterpolator };
Interpolator.recon = function (i0, i1) {
    if (i0 === undefined && i1 === undefined) {
        return new ReconInterpolator();
    }
    if (i0 !== undefined) {
        i0 = Item.fromAny(i0);
    }
    if (i1 !== undefined) {
        i1 = Item.fromAny(i1);
    }
    if (!i0 && !i1) {
        i1 = i0 = Item.Absent;
    }
    else if (!i1) {
        i1 = i0;
    }
    else if (!i0) {
        i0 = i1;
    }
    if (i0 instanceof Field && i1 instanceof Field) {
        if (i0 instanceof Attr && i1 instanceof Attr
            || i0 instanceof Attr && i1.key instanceof Text
            || i1 instanceof Attr && i0.key instanceof Text) {
            return new AttrInterpolator(i0, i1);
        }
        else {
            return new SlotInterpolator(i0, i1);
        }
    }
    var v0 = i0.toValue();
    var v1 = i1.toValue();
    if (v0 instanceof Record && v1 instanceof Record) {
        return new RecordInterpolator(v0, v1);
    }
    else if (v0 instanceof Num && v1 instanceof Num) {
        return new NumInterpolator(v0, v1);
    }
    else if (v0 instanceof InfixExpr && v1 instanceof InfixExpr) {
        return new InfixExprInterpolator(v0, v1);
    }
    else if (v0 instanceof PrefixExpr && v1 instanceof PrefixExpr) {
        return new PrefixExprInterpolator(v0, v1);
    }
    else if (v0 instanceof InvokeExpr && v1 instanceof InvokeExpr) {
        return new InvokeExprInterpolator(v0, v1);
    }
    return new ValueInterpolator(v0, v1);
};
//# sourceMappingURL=data:application/json;base64,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